<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="circle-info"
			class="svg-inline--fa fa-circle-info"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 336c-8.844 0-16 7.156-16 16v0c0 8.844 7.156 16 16 16s16-7.156 16-16v0C272 343.2 264.8 336 256 336zM256 176c-13.25 0-24 10.75-24 24v112c0 13.25 10.75 24 24 24s24-10.75 24-24V200C280 186.8 269.3 176 256 176z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 128c-17.36 0-31.44 14.08-31.44 31.44C224.6 176.8 238.6 190.9 256 190.9s31.44-14.08 31.44-31.44C287.4 142.1 273.4 128 256 128zM256 208c-13.25 0-24 10.75-24 24v128c0 13.25 10.75 24 24 24s24-10.75 24-24V232C280 218.8 269.3 208 256 208z"
			></path>
			<path
				class="solid"
				fill="currentColor"
				d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64a32 32 0 1 1 0-64z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'CircleInfoIcon',
	components: { Icon },
	props,
}
</script>
